import { Navigate, Outlet, useLocation } from 'react-router';

import { useUser } from '@/components/auth-provider';
import { useRole } from '@/hooks/use-role';

export function PrivateRoute() {
  const { user } = useUser();
  const { isEmployee } = useRole();
  const location = useLocation();

  if (!user) {
    return <Navigate to="/" replace />;
  }

  // Redirect un-onboarded users to the onboarding wizard,
  // but don't redirect if they're already there.
  if (!user.onboarded && location.pathname !== '/onboarding') {
    return <Navigate to="/onboarding" replace />;
  }

  // Redirect onboarded users away from onboarding back to their home route.
  if (user.onboarded && location.pathname === '/onboarding') {
    return <Navigate to={isEmployee ? '/schedule' : '/jobs'} replace />;
  }

  return <Outlet />;
}
